import React from "react";
import { Menu } from "antd";
import { Link } from "react-router-dom";

import CustomScrollbars from "util/CustomScrollbars";
import SidebarLogo from "./SidebarLogo";
import UserProfile from "./UserProfile";
import AppsNavigation from "./AppsNavigation";
import {
  NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  THEME_TYPE_LITE,
} from "../../constants/ThemeSetting";
import IntlMessages from "../../util/IntlMessages";
import { useSelector } from "react-redux";
import { useAuth } from "../../authentication";
const SubMenu = Menu.SubMenu;

const SidebarContent = ({ sidebarCollapsed, setSidebarCollapsed }) => {
  const { navStyle, themeType } = useSelector(({ settings }) => settings);
  const pathname = useSelector(({ common }) => common.pathname);

  const getNoHeaderClass = (navStyle) => {
    if (
      navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR ||
      navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR
    ) {
      return "gx-no-header-notifications";
    }
    return "";
  };

  const selectedKeys = pathname.substr(1);
  const defaultOpenKeys = selectedKeys.split("/")[1];
  const { authUser, isLoadingUser } = useAuth();

  return (
    <>
      <SidebarLogo
        sidebarCollapsed={sidebarCollapsed}
        setSidebarCollapsed={setSidebarCollapsed}
      />
      <div className="gx-sidebar-content">
        <div
          className={`gx-sidebar-notifications ${getNoHeaderClass(navStyle)}`}
        >
          <UserProfile />
          <AppsNavigation />
        </div>
        <CustomScrollbars className="gx-layout-sider-scrollbar">
          <Menu
            defaultOpenKeys={[defaultOpenKeys]}
            selectedKeys={[selectedKeys]}
            theme={themeType === THEME_TYPE_LITE ? "lite" : "dark"}
            mode="inline"
          >
            <SubMenu key="main" title="اطلاعات وب سایت">
              <Menu.Item key="baseData/projects">
                <Link to="/baseData/projects">
                  <i className="icon icon-dasbhoard" />
                  پروژه ها
                </Link>
              </Menu.Item>
              <Menu.Item key="baseData/standards">
                <Link to="/baseData/standards">
                  <i className="icon icon-dasbhoard" />
                  استاندارد ها
                </Link>
              </Menu.Item>
              <Menu.Item key="baseData/setting">
                <Link to="/baseData/setting">
                  <i className="icon icon-dasbhoard" />
                  اطاعات پایه وب سایت
                </Link>
              </Menu.Item>
              <Menu.Item key="website/sliders">
                <Link to="/website/sliders">
                  <i className="icon icon-dasbhoard" />
                  اسلایدر
                </Link>
              </Menu.Item>
            </SubMenu>
            <SubMenu key="contactus" title="ارتباط با ما">
              <Menu.Item key="website/contactUs">
                <Link to="/website/contactUs">
                  <i className="icon icon-dasbhoard" />
                  ارتباط با ما
                </Link>
              </Menu.Item>
            </SubMenu>
          </Menu>
        </CustomScrollbars>
      </div>
    </>
  );
};

export default React.memo(SidebarContent);
